import { useState } from "react";
import { useSelector } from "react-redux";
import { Pagination, Spin } from "antd";

import "./editorOrganizations.css";

//Components
import OrganizationDetails from "../../components/editOrganizations/OrganizationDetails";
import OrganizationForm from "../../components/editOrganizations/OrganizationForm";

const EditorOrganizations = () => {
  const organizations = useSelector(state => state.organizations.organizations);

  // State for current page and items per page (for pagination)
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(6);

  //handlers
  const onPageChange = page => {
    setCurrentPage(page);
  };

  // Calculate the current items to show based on the current page and items per page
  const currentItems = organizations
    ? organizations.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      )
    : [];

  return (
    <div
      className="home-editor-organizations"
      id="editor-organizations-home-page"
    >
      {false ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh"
          }}
        >
          <Spin size="large" />
        </div>
      ) : (
        <>
          <div id="sidebar-organizations-form">
            <OrganizationForm
              organizations={
                organizations
                  ? organizations.filter(item => {
                      // console.debug("item.isPartOfGroup", item.isPartOfGroup);
                      // console.debug("item.parentCompany", item.parentCompany);
                      return item.isPartOfGroup && item.parentCompany === ""
                        ? true
                        : false;
                    })
                  : []
              }
            />
          </div>
          <div id="organizations-main">
            <div className="organizations" id="editor-organizations-page">
              {currentItems &&
                currentItems.map(organization => (
                  <OrganizationDetails
                    key={organization._id}
                    organization={organization}
                    parentCompany={
                      organization?.parentCompany && organizations
                        ? organizations.find(
                            org => org._id === organization.parentCompany
                          )?.customerName ?? ""
                        : ""
                    }
                  />
                ))}
            </div>
            <Pagination
              id="editor-organizations-page-pagination"
              current={currentPage}
              total={organizations ? organizations?.length : 0}
              showSizeChanger={false}
              pageSize={itemsPerPage}
              onChange={onPageChange}
              style={{ display: "block" }}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default EditorOrganizations;
